import { NodeType } from "@iventis/domain-model/model/nodeType";
import { Node } from "@iventis/domain-model/model/node";
import { findNode, findParentNodeByType } from "../tree-operations";

export const allowedParentTypes = [NodeType.Folder, NodeType.MappingLibrary, NodeType.PersonalMappingLibrary];

/** Finds a valid parent which is a folder which is not inside a map */
export const findValidParentNode = (tree: Node, moveToNode: Node): Node => {
    if (moveToNode.type === NodeType.MappingLibrary || moveToNode.type === NodeType.PersonalMappingLibrary) {
        return moveToNode;
    }
    const parentNode = findNode([tree], moveToNode.parentId);
    // If the any of the parent node is a map then we know the folder is inside the map
    const isParentNodeValid = findParentNodeByType(tree, NodeType.Map, parentNode, false) == null && parentNode.type !== NodeType.Map;

    if (moveToNode.type === NodeType.Folder && isParentNodeValid) {
        return moveToNode;
    }

    return findValidParentNode(tree, parentNode);
};
